import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import {XMedicalCoreModule, PipesModule} from '@xmedical/core';
import {XMEDICAL_UI_STANDALONE_EXPORTS} from './xmedical-ui.imports';

@NgModule({
  imports: [
    CommonModule,
    XMedicalCoreModule,
    PipesModule,
    ...XMEDICAL_UI_STANDALONE_EXPORTS,
  ],
  exports: [
    CommonModule,
    PipesModule,
    ...XMEDICAL_UI_STANDALONE_EXPORTS
  ],
  providers: [
    DatePipe
  ]
})
export class XmedicalUiModule { }
